import { render } from "./AlbumCreateModal.vue?vue&type=template&id=7f1efd70&scoped=true&ts=true"
import script from "./AlbumCreateModal.vue?vue&type=script&lang=ts"
export * from "./AlbumCreateModal.vue?vue&type=script&lang=ts"

import "./AlbumCreateModal.vue?vue&type=style&index=0&id=7f1efd70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1efd70"]])

export default __exports__